module.exports = __webpack_public_path__ + "static/media/MenuWhite.dac1a11b.svg";